import {DropDownOption} from "../interfaces/drop-down-option.interface";

export const BARRIER_BREAK: DropDownOption[] = [
  { id: 'BACK_IN_FOR_PERIOD', displayValue: 'Back In for Period' },
  // { id: 'OUT_FOR_PERIOD', displayValue: 'Out for Period'}
]
